import React from 'react';
import PropTypes from 'prop-types';
import css from './SlotsListHeader.css';

export default class SlotsListHeader extends React.Component {

  get label() {
    const { availableSlots, time } = this.props;
    return `${availableSlots} available slot${availableSlots > 1 ? 's' : ''} for ${time}`;
  }

  render() {    
    return (
      <div className={css['header-container']} aria-label={this.label}>
        <div>{this.props.time}</div>
        <div>{`${this.props.availableSlots} available`}</div>
      </div>
    );
  }
}

SlotsListHeader.propTypes = {
  availableSlots: PropTypes.number.isRequired,
  time: PropTypes.string.isRequired
};
